import { IApplicationState } from '../../types/redux';

export function getBlackFridayActive(state: IApplicationState) {
  return state.config.newbuildingBlackFriday.isActive;
}
